/* eslint-disable */
/**
 * AUTO-GENERATED FILE — DO NOT EDIT.
 *
 * Generated by: scripts/generate-embedded-react-exports.mjs
 * Source: react@18.3.1 (ESM entry)
 * Generated at: 2026-01-17T18:59:01.271Z
 */

export const EMBEDDED_REACT_18_VERSION = "18.3.1" as const;

export const EMBEDDED_REACT_18_NAMED_EXPORTS = [
  "__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED",
  "act",
  "Children",
  "cloneElement",
  "Component",
  "createContext",
  "createElement",
  "createFactory",
  "createRef",
  "forwardRef",
  "Fragment",
  "isValidElement",
  "lazy",
  "memo",
  "Profiler",
  "PureComponent",
  "startTransition",
  "StrictMode",
  "Suspense",
  "unstable_act",
  "useCallback",
  "useContext",
  "useDebugValue",
  "useDeferredValue",
  "useEffect",
  "useId",
  "useImperativeHandle",
  "useInsertionEffect",
  "useLayoutEffect",
  "useMemo",
  "useReducer",
  "useRef",
  "useState",
  "useSyncExternalStore",
  "useTransition",
  "version"
] as const;
